import { CHECK_OLD_PASSWORD, CHECK_OLD_PASSWORD_DONE, CHECK_OLD_PASSWORD_ERROR, CHECK_OLD_PASSWORD_RESET } from './actionTypes';
export const checkOldPassword = (data) => ({
    type: CHECK_OLD_PASSWORD,
    data
});
export const checkOldPasswordDone = (data) => ({
    type: CHECK_OLD_PASSWORD_DONE,
    data
});
export const checkOldPasswordError = (data) => ({
    type: CHECK_OLD_PASSWORD_ERROR,
    data
});
export const checkOldPasswordReset = () => ({
    type: CHECK_OLD_PASSWORD_RESET
});
//# sourceMappingURL=actionCreators.js.map